import React from 'react';
import './index.css';

import { roofTypesMap } from "../../config/config";
import { IRoof } from "../../react-app-env";
import useKeyDownHandler from "../../hooks/useKeyDown";
import ErrorIndicator from "../ErrorIndicator";

interface P {
    i18nMap: any
    selectedRoofType: string
    selectRoofType: any
    roof?: IRoof
    hasError: boolean
    disableFields: boolean
    isActive: boolean
}

export default ({ i18nMap, selectedRoofType, selectRoofType, roof, hasError, disableFields, isActive, }: P) => {
    let isFlat = roof ? roof.slope <= 7 : false;
    const handleKeyDown = useKeyDownHandler({ onAction: selectRoofType });
    return (
        <>
            {hasError && selectedRoofType === roofTypesMap[0].type && (
                <div style={{display: 'flex', justifyContent: 'center'}}>
                    <ErrorIndicator error={i18nMap.selectRoofType}/>
                </div>
            )}

            <div className={`image-items-holder`}>
                {roofTypesMap.map((roofType, key) => {
                    const isPlaceholder = roofType.type === 'unselected';
                    let isDisabled = (roofType.type === 'normal' && isFlat) || disableFields;
                    return (<div
                        key={key}
                        id={roofType.i18nName}
                        tabIndex={isActive && !isPlaceholder ? 0 : -1}
                        className={`image-item-holder image-item-holder-${roofType.i18nName === selectedRoofType && 'selected'} ${isDisabled && 'disabled-field'} ${isPlaceholder ? 'roof-type-placeholder' : ''}`}
                        onClick={() => !isDisabled && !isPlaceholder && selectRoofType(roofType.i18nName)}
                        onKeyDown={(e) => !isDisabled && !isPlaceholder && handleKeyDown(e, roofType.i18nName)}
                    >
                        <img src={`/assets/${roofType.imgName}`} className={`image-item-img`} alt={''}/>
                        <div className={`image-item non-selectable`}>{i18nMap[roofType.i18nName]}</div>
                    </div>);
                })}
            </div>
        </>
    );
};